import React from "react";

export function PageContainer({ children, className = "" }) {
  return (
    <div className={`w-full px-6 lg:px-8 py-5 lg:py-6 ${className}`}>
      {children}
    </div>
  );
}

export function SectionHeader({ title, description, action, className = "" }) {
  return (
    <div className={`flex items-end justify-between gap-4 mb-5 ${className}`}>
      <div>
        <h2 className="text-lg font-semibold tracking-tight">{title}</h2>
        {description && (
          <p className="text-sm text-muted-foreground mt-0.5">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}

export default PageContainer;
